const QueryString = require('../lib/QueryString').default;
var PageNews = {
  data(){
    return{
      infoID: QueryString.parse().id || -1,
      information: {}
    }
  },
  computed:{

  },
  created(){
    //インフォメーション
    this.information = this.informations.find((info) => {
      return this.infoID == info.ID
    })
    if (!this.information) {
      location.replace('../')
    }
    console.log(this.information)
  },
  mounted(){
    
  },
  methods: {

  }
}

module.exports = PageNews